import type { FaireProductEntity } from "../../entity_types/product";

export const p_2zbekgtd4t: FaireProductEntity = {
  token: "p_2zbekgtd4t",
  type: "product",
  name: "Roster Dinner Napkin Set",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/6a624a081678ec9a4c9f72ecbd1486a6b1d978264e55ba8554fbe7f8fd1a65e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1ae6ad91292502136345e516988d8e2b7f89c24bb8d28c17b572ea3d04a57e0.jpeg"
  ],
  priceDollars: 15,
  description: "Dinner Napkin Set - 6 Pack\n\nBring style to the table. \n\nMessy fingers are as helpless against our Dinner Napkins as boring tablescapes are. The Geometry Dinner Napkin Set transforms ordinary meals into festive events – no invitations required. Created from our soft, durable Geosuede(™) fabric and available in countless prints and patterns, you’re sure to invite these back to the table. Sold as a set of 6.\n\n...\n\n♺ Made from post-consumer recycled materials\n\n19\" x 19\"\n\nSet of 6 dinner napkins\n\nSingle-sided print\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n...\n\nDine Responsibly.\n\nWith its natural softness and ultra-absorbent weave, our Dinner Napkin Sets are guaranteed a seat at your table – but they’re also friendly to the environment. Our Dinner Napkins are created from post-consumer recycled products and manufactured using less water than traditional methods, minimizing our carbon footprint. And due to its weave, high absorbency and quick dry time, you can wash less often, helping to minimize yours. \n\n\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:57.685Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
